import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from '@/apis/api';
import headerObject from '@/types/headerObj';

const endpoint = apiUrl + 'fetchDatasources/';

export const fetchDataSources = async ({
  orgUUID,
  UserUUID,
  headerObj,
}: {
  orgUUID?: string;
  UserUUID?: string;
  headerObj: headerObject;
}) => {
  try {
    const response = await postWithAuth(endpoint, {
      OrgUUID: orgUUID,
      UserUUID: UserUUID,
    });

    if (!response.ok) {
      throw new Error('Failed to fetch data sources');
    }

    const text = await response.json();
    return JSON.parse(text);
  } catch (err) {
    console.error(err);
  }
};
